<div class="logo-editor">
  <div class="logo-editor__header">
    <h3 class="logo-editor__header-title">Logo</h3>
    <button type="button" class="logo-editor__close-btn" (click)="onClose()" aria-label="Close">&times;</button>
  </div>
  <div class="logo-editor__body">
    <!-- In / Out (edit mode only, same as text-styling-panel) -->
    <div class="logo-editor__section" *ngIf="isEditMode">
      <label class="logo-editor__label">In</label>
      <div class="logo-editor__time-row">
        <div class="logo-editor__time-input-wrap">
          <input
            type="text"
            class="logo-editor__time-input"
            [value]="inTimecode"
            (blur)="onInTimeBlur($event)"
            placeholder="00:00:00.000"
          />
          <button
            type="button"
            class="logo-editor__time-now-btn"
            title="Set to current playhead time"
            (click)="setInToPlayhead()"
            aria-label="Set In to playhead"
          >
            Now
          </button>
        </div>
      </div>
      <label class="logo-editor__label">Out</label>
      <div class="logo-editor__time-row">
        <div class="logo-editor__time-input-wrap">
          <input
            type="text"
            class="logo-editor__time-input"
            [value]="outTimecode"
            (blur)="onOutTimeBlur($event)"
            placeholder="00:00:00.000"
          />
          <button
            type="button"
            class="logo-editor__time-now-btn"
            title="Set to current playhead time"
            (click)="setOutToPlayhead()"
            aria-label="Set Out to playhead"
          >
            Now
          </button>
        </div>
      </div>
    </div>

    <!-- Scale (0.1 - 3.0) -->
    <div class="logo-editor__section">
      <label class="logo-editor__label">Scale</label>
      <div class="logo-editor__scale-row">
        <input
          type="range"
          class="logo-editor__slider"
          [min]="scaleMin"
          [max]="scaleMax"
          [step]="scaleStep"
          [value]="scale"
          (input)="onScaleChange(($any($event.target).value))"
        />
        <input
          type="number"
          class="logo-editor__number"
          [min]="scaleMin"
          [max]="scaleMax"
          [step]="scaleStep"
          [ngModel]="scale"
          (ngModelChange)="onScaleChange($event)"
        />
      </div>
    </div>

    <!-- Rotation (0 - 360°) -->
    <div class="logo-editor__section">
      <label class="logo-editor__label">Rotation (°)</label>
      <div class="logo-editor__scale-row">
        <input
          type="range"
          class="logo-editor__slider"
          [min]="rotationMin"
          [max]="rotationMax"
          [value]="rotationDeg"
          (input)="onRotationChange(($any($event.target).value))"
        />
        <input
          type="number"
          class="logo-editor__number"
          [min]="rotationMin"
          [max]="rotationMax"
          [ngModel]="rotationDeg"
          (ngModelChange)="onRotationChange($event)"
        />
      </div>
    </div>
  </div>
  <div class="logo-editor__footer">
    <button type="button" class="logo-editor__save-btn" (click)="onSave()">Save Changes</button>
  </div>
</div>
